module.exports = __webpack_public_path__ + "static/img/pic01.6e70775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/bbs/pic01.png
// module id = zfP7
// module chunks = 2